var background = $('.backgroundHeader');
var navbar = $('#navbarCollapse');
var closeButton = $('.closeNav');

$(document).ready(function() {
  closeButton.on('click', function() {
    navbar.collapse('hide');
  })
    $('[data-toggle="sticky-onscroll"]').each(function() {
      var sticky = $(this);
      var stickyWrapper = $('<div>').addClass('sticky-wrapper');
      sticky.before(stickyWrapper);
      stickyWrapper.addClass('d-none d-md-block')
      sticky.addClass('sticky');
      $(window).on('scroll.sticky-onscroll resize.sticky-onscroll', function() {
        stickyToggle(sticky, stickyWrapper, $(this));
      });
      stickyToggle(sticky, stickyWrapper, $(window));
    });
});


// STICKY MENU
function stickyToggle(sticky, stickyWrapper, scrollElement) {
  var stickyHeight = sticky.outerHeight();
  var stickyTop = stickyWrapper.offset().top;
  if (scrollElement.scrollTop() > stickyTop) {
    sticky.addClass("is-sticky");
      background.stop();
      background.animate({"bottom": "0"}, "fast");
      background.css("border-bottom", "3px solid #9dcd59")
  } else {
    sticky.removeClass("is-sticky");
    if (!navbar.hasClass('show')) {
      background.stop();
      background.animate({"bottom": stickyHeight}, "fast", function() {
        background.css("border-bottom", "none")
      });
    }
  }
};


navbar.on('shown.bs.collapse', function() {
  if ($(window).scrollTop() == 0) {
    background.animate({"bottom": "0"}, "fast");
  }
  $('.navbar-collapse').css('top', $('[data-toggle="sticky-onscroll"]').height())
  $('body').append('<div id="grayBackground"></div>');
  $('#grayBackground').animate({'opacity': '.5'}, "fast");
});

navbar.on('hide.bs.collapse', function() {
  if ($(window).scrollTop() == 0) {
    background.animate({"bottom": $('[data-toggle="sticky-onscroll"]').outerHeight()}, "fast");
  }
  $('#grayBackground').animate({'opacity': '0'}, "fast");
});

navbar.on('hidden.bs.collapse', function() {
  $('body').css('position', 'unset');
  $('#grayBackground').remove();
});

$(document).on('click', function(e) {
  if($(e.target).is('#grayBackground')) {
    navbar.collapse('hide');
  }
});
